import { Component, OnInit, Input } from '@angular/core';
import { Select2Data } from 'ng-select2-component';
import { DocumentService } from '../../../services/document.service';
import Swal from 'sweetalert2';
import { saveAs } from 'file-saver';
import { StihlDocumentDTO } from 'src/app/models/stihl-document-dto';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { LogType } from '../../../enums/logType';
import { HttpEventType } from '@angular/common/http';
import { LastUpdatesModelDTO } from 'src/app/models/lastupdates';
import { ToastrService } from 'ngx-toastr';
import { TrackingService } from 'src/app/services/tracking.service';
import { heightContentAnimation } from 'src/app/animations';


@Component({
  selector: 'app-documents-card',
  templateUrl: './documentsCards.component.html',
  animations: [heightContentAnimation]
})
export class documentsCardsComponent implements OnInit {


  @Input() idOrganization: string;
  data: StihlDocumentDTO[];
  idOrganizationFilter: string;
  idYearFilter: string = '0';
  idMonthFilter: string = '0';
  organizationMonth: boolean = false;
  public OrganizationData: Select2Data;
  public yearData: Select2Data;
  public monthData: Select2Data;
  progress: number = 0;
  showProgress: boolean = false;

  constructor(private documentService: DocumentService, private toastr: ToastrService, private sanitizer: DomSanitizer, private trackingService: TrackingService) { }

  ngOnInit(): void {
    this.idOrganizationFilter = this.idOrganization;

    this.loadData();
    this.setDatatable();
  }

  setDatatable() {
    const that = this;

    that.documentService.getDataClientCards(this.idOrganizationFilter, +this.idYearFilter, +this.idMonthFilter).subscribe(resp => {
      that.data = resp;
    }, (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Erro ao recuperar os dados',
        text: 'Ocorreu um erro'
      });

    });
  }

  loadData() {
    const that = this;

    this.documentService.GetOrganizationFilter(this.idOrganization).subscribe(resp => {
      this.organizationMonth = resp;
    }, (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Erro ao recuperar os dados',
        text: 'Ocorreu um erro'
      });
    });

    this.documentService.GetDocumentOrganization(this.idOrganization).subscribe(resp => {
      var todosData = { value: this.idOrganization, label: 'TODOS LOS DOCUMENTOS' };
      resp.splice(0, 0, todosData);
      that.idOrganizationFilter = this.idOrganization;
      this.OrganizationData = resp;
      this.loadYear();
    }, (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Erro ao recuperar os dados',
        text: 'Ocorreu um erro'
      });
    });

  }

  onChangeOrganization(event) {
    if (event == null) event = this.idOrganization;
    this.idMonthFilter = '0';
    this.idYearFilter = '0';
    this.loadYear();
  }

  onChangeYear(event) {
    if (event == null) event = 0;
    this.idMonthFilter = '0';
    this.loadMonth();
  }

  loadYear() {
    this.documentService.GetDocumentYear(this.idOrganizationFilter).subscribe(resp => {
      var todosData = { value: '0', label: 'TODOS OS ANOS' };
      resp.splice(0, 0, todosData);
      this.yearData = resp;
      this.loadMonth();
    }, (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Erro ao recuperar os dados',
        text: 'Ocorreu um erro'
      });
    });
  }

  loadMonth() {
    this.documentService.GetDocumentMonth(this.idOrganizationFilter, +this.idYearFilter).subscribe(resp => {
      var todosData = { value: '0', label: 'TODOS OS MESES' };
      resp.splice(0, 0, todosData);
      this.monthData = resp;
    }, (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Erro ao recuperar os dados',
        text: 'Ocorreu um erro'
      });
    });
  }


  //#region MÉTODOS DE DESCARGA SI SE OPTA POR MANTENERLO COMO EN SLP ESPAÑA
  downloadDocument(idDocument, documentName) {

    this.showProgress = true;

    this.documentService.getDocumentFileProgress(idDocument).subscribe(
      (event) => {

        if (event.type === HttpEventType.DownloadProgress) {

          this.progress = Math.round(100 * event.loaded / event.total);

        } else if (event.type === HttpEventType.Response) {

          this.showProgress = false;
          this.progress = 0;

          saveAs(event.body, documentName);

        }

      },
      (err) => {
        this.toastr.error(
          'No se pudo descargar el archivo',
          'Descarga de archivo',
          { timeOut: 2000 }
        );
      }
    );
    this.trackDocument(idDocument);
  }

  trackDocument(idDocument) {
    this.trackingService
      .trackDocument(idDocument, LogType.Download)
      .subscribe();
  }
  //#endregion


  rerender(): void {

    if (this.idOrganizationFilter.length == 0) {
      this.idOrganizationFilter = this.idOrganization;
    }

    this.setDatatable();
  }


}
